import React, { Component } from 'react';
import { isEmpty } from 'lodash-es';
import { Icon, Spin } from 'components/antd';

import { GoogleAddressAndFlightData } from 'app-types';
import { isNoFlights, isEnoughLettersForSearch } from 'utils/flightsUtils';

import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
	inputValue?: string;
	isAddressLoading: boolean;
	addressesSuggestions?: GoogleAddressAndFlightData[];
}

export default class NotFound extends Component<Props> {
	render() {
		const { inputValue, isAddressLoading, addressesSuggestions } = this.props;
		if (isAddressLoading) {
			return (
				<div className={styles.searchingContainer}>
					<div>
						<Spin size="small" />
					</div>
					<div>Searching...</div>
				</div>
			);
		}

		if (isNoFlights(addressesSuggestions)) {
			// case of searching of flight
			return (
				<div className={classNames(styles.searchingContainer, styles.notFound)}>
					<Icon type="searchNoResults" />
					<div>No results found.</div>
					<div>Please make sure the pickup date you selected is the flight date</div>
				</div>
			);
		}

		if (isEmpty(addressesSuggestions) && isEnoughLettersForSearch(inputValue)) {
			// case of searching of address
			return (
				<div className={classNames(styles.searchingContainer, styles.notFound)}>
					<Icon type="searchNoResults" />
					<div>No results found</div>
				</div>
			);
		}

		return null;
	}
}
